export default "__VITE_ASSET__faeb84ff__"